import { render, staticRenderFns } from "./MonthlyCollapseList.vue?vue&type=template&id=16e852a5&scoped=true"
import script from "./MonthlyCollapseList.vue?vue&type=script&lang=js"
export * from "./MonthlyCollapseList.vue?vue&type=script&lang=js"
import style0 from "./MonthlyCollapseList.vue?vue&type=style&index=0&id=16e852a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e852a5",
  null
  
)

export default component.exports